// D:\directiveai-react\frontend\src\components\home\HomeInput\styles\AssistantStyle.js
import React from 'react';
import AssistantLayout from '../layouts/AssistantLayout';

const AssistantStyle = {
  getContainerStyles: (theme) => {
    // Usar background transparente si es modo wallpaper
    const isWallpaperMode = theme.palette.actualMode === 'wallpaper';

    if (isWallpaperMode) {
      return { backgroundColor: 'transparent' };
    }

    return {
      backgroundColor: theme.palette.mode === 'dark' ? '#000000' : '#FFFFFF',
    };
  },

  getTextFieldStyles: () => ({}),
  
  getPromptCardStyles: (theme) => {
    const isWallpaperMode = theme.palette.actualMode === 'wallpaper';

    return {
      borderRadius: '16px',
      backgroundColor: isWallpaperMode
        ? 'rgba(128, 128, 128, 0.3)'
        : (theme.palette.mode === 'dark' ? '#1C1C1E' : '#F2F2F7'),
      backdropFilter: isWallpaperMode ? 'blur(10px)' : 'none',
      WebkitBackdropFilter: isWallpaperMode ? 'blur(10px)' : 'none',
      boxShadow: theme.palette.mode === 'dark'
        ? '0 4px 12px rgba(0, 0, 0, 0.5)'
        : '0 4px 12px rgba(0, 0, 0, 0.1)',
    };
  },
  
  getRefreshButtonStyles: (theme) => {
    const isWallpaperMode = theme.palette.actualMode === 'wallpaper';

    return {
      backgroundColor: isWallpaperMode
        ? 'rgba(128, 128, 128, 0.3)'
        : (theme.palette.mode === 'dark' ? '#1C1C1E' : '#F2F2F7'),
      borderRadius: '50%',
      backdropFilter: isWallpaperMode ? 'blur(10px)' : 'none',
      WebkitBackdropFilter: isWallpaperMode ? 'blur(10px)' : 'none',
      boxShadow: theme.palette.mode === 'dark'
        ? '0 4px 12px rgba(0, 0, 0, 0.5)'
        : '0 4px 12px rgba(0, 0, 0, 0.1)',
      '&:hover': {
        backgroundColor: isWallpaperMode
          ? 'rgba(128, 128, 128, 0.5)'
          : (theme.palette.mode === 'dark' ? '#2C2C2E' : '#E9E9EB'),
      }
    };
  },
  
  getStylePreviewConfig: (theme) => {
    const isWallpaperMode = theme.palette.actualMode === 'wallpaper';

    return {
      backgroundColor: theme.palette.mode === 'dark' ? '#000000' : '#FFFFFF',
      borderRadius: '16px',
      inputStyle: {
        borderRadius: '20px',
        backgroundColor: isWallpaperMode
          ? 'rgba(128, 128, 128, 0.3)'
          : (theme.palette.mode === 'dark' ? '#1C1C1E' : '#F2F2F7'),
        backdropFilter: isWallpaperMode ? 'blur(10px)' : 'none',
        WebkitBackdropFilter: isWallpaperMode ? 'blur(10px)' : 'none',
        boxShadow: theme.palette.mode === 'dark'
          ? '0 4px 12px rgba(0, 0, 0, 0.5)'
          : '0 4px 12px rgba(0, 0, 0, 0.1)',
      },
      cardStyle: {
        borderRadius: '16px',
        backgroundColor: isWallpaperMode
          ? 'rgba(128, 128, 128, 0.3)'
          : (theme.palette.mode === 'dark' ? '#1C1C1E' : '#F2F2F7'),
        backdropFilter: isWallpaperMode ? 'blur(10px)' : 'none',
        WebkitBackdropFilter: isWallpaperMode ? 'blur(10px)' : 'none',
        boxShadow: theme.palette.mode === 'dark'
          ? '0 4px 12px rgba(0, 0, 0, 0.5)'
          : '0 4px 12px rgba(0, 0, 0, 0.1)',
      }
    };
  },
  
  // Renderizar el layout correspondiente y pasar cualquier prop recibida, incluyendo la función de traducción
  renderLayout: (props) => <AssistantLayout {...props} />
};

export default AssistantStyle;